<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="page-title">
                    <h2>{{'sidebar.products_list' | translate}}</h2>
                </div>
            </div>
        </div>

        <div class="modal fade" id="deleteConfirmModal" tabindex="-1" aria-labelledby="deleteConfirmModalLabel"
            aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="deleteConfirmModalLabel">{{'common.confirmation' | translate}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        {{'common.confirm_delete' | translate}}
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{'common.cancel' |
                            translate}}</button>
                        <button type="button" class="btn btn-danger" (click)="confirmDelete()">{{'common.delete' |
                            translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9" *ngIf="loading" style="text-align: center;">{{'common.loading' | translate}} ...</div>
            <div class="col-md-9" *ngIf="!loading">
                <div class="recent-orders">
                    <br />
                    <br />
                    <div class="table-responsive">
                        <button (click)="newOffer()" class="btn btn-success btn-xs btn-add-product">
                            <i class="fa fa-signs-post"></i>
                            {{'common.sell_a_product' | translate}}
                        </button>
                        <table class="table table-striped" id="my-offers">
                            <thead>
                                <tr class="first last">
                                    <th>{{'product.product' | translate}}</th>
                                    <th>{{'common.quantity' | translate}}</th>
                                    <th>{{'common.unit_price' | translate}}</th>
                                    <th>{{'common.status' | translate}}</th>
                                    <th>{{'common.created_at' | translate}}</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let offer of data | paginate: config" id="offer-{{ offer.id }}">
                                    <td>{{ currentLanguage == 'fr'? offer.product.productNameFr :
                                        offer.product.productName }}</td>
                                    <td>{{ offer.qty }}</td>
                                    <td>{{ offer.price }} {{ offer.currency | uppercase }}</td>
                                    <td> {{ getStatus(offer.status) | translate}}</td>
                                    <td> {{ offer.creationDate }}</td>
                                    <td>
                                        <a class="view me-2" (click)="viewOffer(offer)"
                                            title="{{'common.view' | translate}}">
                                            <i class="fa fa-eye"></i>
                                        </a>

                                        <a class="view me-2" [routerLink]="[offer.id , 'sales']"
                                            title="{{'common.sales' | translate}}">
                                            <i class="fa fa-edit fa-edit-link"></i>
                                        </a>

                                        <a class="view" (click)="openDeleteModal(offer)"
                                            title="{{'common.delete' | translate}}">
                                            <i class="fa fa-trash"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="toolbar" *ngIf="!loading">
                        <div class="pager">
                            <pagination-controls class="pages" maxSize="5" previousLabel="Previous" nextLabel="Next"
                                autoHide="true" id="products" (pageChange)="pageChange($event)">

                            </pagination-controls>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <app-sidebar [currentUser]="user"></app-sidebar>
            </div>
        </div>
    </div>
</div>